document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  var tagRef = params.get('tag_ref');

  if (!tagRef) return;

  var attributesPayload;

  if (tagRef === 'void') {
    attributesPayload = { tag_ref: '' }; // clears attribute
  } else {
    attributesPayload = { tag_ref: tagRef };
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributesPayload })
  }).then(function () {
    // Build a clean URL without tag_ref
    var url = new URL(window.location.href);
    url.searchParams.delete('tag_ref');

    // Reload the page so Liquid sees the updated cart.attributes
    window.location.replace(url.toString());
  });
});